import React, {ChangeEvent, FC, useEffect, useState} from 'react';
import HeaderLogo from "../../components/HeaderLogo";
import NpsHead from "./NpsHead";
import TextArea from "antd/es/input/TextArea";
import css from './Nps.module.scss';
import {useQuery} from "../../hooks/useQuery";
import {NpsTranslation, NpsTranslationData} from "./interfaces/NpsTranslationData";
import {useFetching} from "../../hooks/useFetching";
import SelectGroup from "../../components/SelectGroup/SelectGroup";
import CheckboxGroup from "../../components/CheckboxGroup/CheckboxGroup";
import {getReasons} from "./helpers/getReasons";
import {getCommentQuestion} from "./helpers/getCommentQuestion";
import {getSubReasons} from "./helpers/getSubReasons";
import $api from "../../http";
import {useNavigate} from "react-router-dom";
import RadioGroup from "../../elements/RadioGroup";
import {getPoints} from "./helpers/getPoints";
import {RouteNames} from "../../router";
import Button from "../../elements/Button/Button";

const Nps: FC = () => {
    const MIN_POSITIVE_POINT = 7;
    const [npsResult, setNpsResult] = useState<number>(0);
    const [reason, setReason] = useState<number>(0);
    const [comment, setComment] = useState<string>('');
    const [subReason, setSubReason] = useState<number[]>([]);
    const [translate, setTranslate] = useState<NpsTranslation>();
    const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(false);
    const countryCode = useQuery('CountryCode');
    const languageCode = useQuery('Language');
    const [messageId] = useQuery('Data').split('||');

    const navigate = useNavigate();

    const [fetchTranslation, isLoading] = useFetching(async (countryCode: string, languageCode: string) => {
        const response = await $api.get<NpsTranslationData>('/Pages/Nps', {
            params: {
                countryCode,
                language: languageCode
            }
        })
        setTranslate(response.data.translation);
    })

    useEffect(() => {
        fetchTranslation(countryCode, languageCode);
    }, [])

    useEffect(() => {
        setIsBtnDisabled(!((npsResult && reason && (comment || subReason.length)) || (Number(npsResult) >= MIN_POSITIVE_POINT)))
    }, [npsResult, reason, comment, subReason])

    const handleNpsRadioChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (Number(Number(e.target.value)) >= MIN_POSITIVE_POINT) {
            setReason(0);
            setSubReason([])
        }
        setNpsResult(Number(e.target.value))
        setComment('')
    }
    const handleReasonChange = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        setComment('');
        if (Number(event.currentTarget.value) > 2) {
            setSubReason([]);
        }
        setReason(Number(event.currentTarget.value));
    }
    const handleCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setComment(e.target.value);
    }
    const handleSubReasonChange = (values: string[]) => {
        setComment('');
        setSubReason(values.map(v => Number(v)));
    }
    const handleSubmit = async () => {
        const result = {
            MessageId: messageId,
            Points: Number(npsResult),
            NpsSelectId: reason === 0 || reason >= MIN_POSITIVE_POINT ? null : reason,
            NpsCheckboxResults: subReason,
            Comment: comment.trim()
        }

        navigate(RouteNames.NPS_THANKS, {
            state: {
                title: Number(npsResult) < MIN_POSITIVE_POINT ? translate?.ThankText3 : translate?.ThankText2,
                description: Number(npsResult) < MIN_POSITIVE_POINT ? translate?.ThankTextDescription3 : translate?.ThankTextDescription2,
                headTitle: translate?.Title,
                buttonTitle: translate?.RedirectJooble,
                linkTitle: translate?.IwantElse,
                countryCode: countryCode,
            }
        })
        await $api.post('/api/Event/SaveNpsResults', result, {
            headers: {
                "Accept": "*/*",
                "Content-Type": "application/json",
            }
        })
    }

    return (
        <div className={css.wrapper}>
            <NpsHead title={translate?.Title}/>
            <HeaderLogo className={css.headerLogo}/>
            <main className={css.main}>
                <h2 className={css.title}>{translate?.Header}</h2>
                <div className={css.npsQuestion}>
                    <p className={css.npsQuestion__content}>{translate?.MainQuestion}</p>
                    <p className={css.npsQuestion__description}>{translate?.MarkExample}</p>
                </div>
                <RadioGroup className={css.radio} name={'points'} value={`${npsResult}`} options={getPoints(10)}
                            onChange={handleNpsRadioChange}/>
                {
                    npsResult !== 0 && npsResult < MIN_POSITIVE_POINT && <div className={css.reason}>
                        <p className={css.reason__question}>{translate?.SecondQuestion}</p>
                        {!isLoading && <SelectGroup className={css.reason__select} options={getReasons(translate)}
                                                    handleChange={handleReasonChange}
                                                    defaultOption={translate!.DefaultOption}/>}
                    </div>
                }
                {
                    (reason > 0 || Number(npsResult) >= MIN_POSITIVE_POINT) && <div className={css.subReason}>
                        <p className={css.subReason__label}>
                            {Number(npsResult) >= MIN_POSITIVE_POINT ? getCommentQuestion(translate, Number(npsResult)) : getCommentQuestion(translate, reason)}
                        </p>
                        {(reason && reason < 3) || (!reason && Number(npsResult) < MIN_POSITIVE_POINT)
                            ? <CheckboxGroup onValueChange={handleSubReasonChange} values={getSubReasons(translate)}/>
                            : <TextArea value={comment} className={css.subReason__comment}
                                        onChange={handleCommentChange}
                                        placeholder={translate?.DefaultText} rows={5}/>

                        }
                    </div>
                }
                <Button onClick={handleSubmit} disabled={isBtnDisabled}>
                    {translate?.ButtonSend}
                </Button>
            </main>
        </div>
    )
}

export default Nps;
